module.exports = __webpack_public_path__ + "fonts/Nunito-ExtraBoldItalic.a6af66e2.ttf";